import React, { useEffect, useRef } from 'react'
import CloseIcon from '../../../../assets/icons/actions/close.svg'

function MessageModal({ title, description, showModal, onClose }) {
  const modalRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  if (!showModal) return null

  return (
    <div>
      <div className="notification-overlay !z-0"></div>
      <div
        ref={modalRef}
        className="notification-modal flex flex-col justify-center items-center rounded-xl bg-white z-20 relative"
      >
        <div
          onClick={onClose}
          className="absolute top-3 right-3 cursor-pointer"
        >
          <img src={CloseIcon} alt="Close" className="w-5 h-5" />
        </div>

        <span className="title">{title}</span>
        <p className="loading-paragraph">{description}</p>
      </div>
    </div>
  )
}

export default MessageModal
